import React from "react";
import LBSelect from '../DesignSystem/LBSelect/LBSelect';
import VPOPCountryStatus from "./VPOPCountryStatus";
import { Flag } from "react-bootstrap-icons"; // optional icon

function VPOPHeader({ countries, selectedISO, onSelectISO }) {

  const selectedCountry = countries.find(c => c.ISO === selectedISO);

  return (
    <div 
      className="
        bg-white 
        border 
        rounded-xl 
        p-6 
        shadow-sm 
        flex 
        items-start 
        gap-10 
        w-full
        mb-08
      "
    >
      {/* LEFT SIDE — Country Overview + Dropdown */}
      <div className="flex flex-col w-1/3 min-w-[260px]">

        {/* Section title */}
        <div className="flex items-center gap-2 mb-2">
          <Flag size={18} className="text-gray-700" />
          <span className="font-semibold text-gray-800">Country Overview</span>
        </div>

        {/* Country Selector */}
        <LBSelect
          options={countries.map(country => ({
            label: country.country,
            value: country.ISO,
            iso: country.ISO
          }))}
          searchable={true}
          placeholder="Select a country"
          value={selectedISO}
          onChange={onSelectISO}
          clearable={false}
        />
      </div>

      {/* RIGHT SIDE — Country Stats */}
      <div className="flex flex-row gap-14 flex-wrap pt-6">
        <VPOPCountryStatus country={selectedCountry} />
      </div>
    </div>
  );
}

export default VPOPHeader;
